import axios from 'axios'

const AI_ENDPOINT = 'https://ai.mosaicoed.com/webhook/lesson-plan-generator'
const AI_TOKEN = 'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiODkyMzc4OTQ0OTI3OSIsInVzZXJuYW1lIjoibW9zYWljbyIsImVtYWlsIjoidGVjaG5pY2FsQG1vc2FpY29lZC5jb20iLCJpYXQiOjE3NTU0NjMzMTJ9.3Zuu6tlDPjY__rFKAxR2JolmlGj53i3lgNN2om2Mj9w'

export interface AILessonPlanPayload {
  number_meetings: number
  date_start_at: string
  name: string
  final_product_kind: string
  purpose: string
  objectives: string[]
  final_product_description: string
  stages: string[]
  synopsis: string
  project_items: {
    contents: Array<{
      id: string
      name: string
      original_codes: string
      cycles: any[]
      grades: any[]
      breadcrumb: string
      lv1_name: string
      lv1_id?: string
      lv2_name?: string
      lv2_id?: string
      lv3_name?: string
      lv3_id?: string
      color: string
      curriculum_kind: string
      curriculum_name: string
      curriculum_id: string
    }>
    specific_skills: Array<{
      id: string
      name: string
      original_codes: string
      cycles: any[]
      grades: any[]
      breadcrumb: string
      lv1_name: string
      lv1_id?: string
      lv2_name?: string
      lv2_id?: string
      lv3_name?: string
      lv3_id?: string
      color: string
      curriculum_kind: string
      curriculum_name: string
      curriculum_id: string
    }>
  }
}

export interface AIActivity {
  title: string
  planning: string
  activity_lv4_items: any[]
}

export interface AIMeeting {
  title: string
  meeting_number: number
  date: string
  activities: AIActivity[]
}

export interface AILessonPlanResponse {
  success: boolean
  project: {
    name: string
    purpose: string
    final_product: string
    total_meetings: number
    start_date: string
  }
  meetings: AIMeeting[]
  summary: {
    total_meetings_created: number
    total_activities: number
    date_range: {
      start: string
      end: string
    }
    items_used: {
      total: number
      unique: any[]
    }
  }
  metadata: {
    generated_at: string
    workflow_version: string
    request_id: string
  }
}

/**
 * Chama o endpoint de IA para gerar o plano de lições
 */
export async function generateLessonPlanWithAI(
  payload: AILessonPlanPayload
): Promise<AILessonPlanResponse> {
  try {
    const response = await axios.post(AI_ENDPOINT, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${AI_TOKEN}`
      },
      timeout: 120000,
    })

    return response.data
  } catch (error: any) {
    console.error('❌ Erro ao chamar API de IA:', error)

    if (error.response) {
      console.error('Status:', error.response.status)
      console.error('Data:', error.response.data)
      throw new Error(
        `Erro da API de IA: ${error.response.data?.message || error.response.statusText}`
      )
    } else if (error.request) {
      throw new Error('Sem resposta da API de IA. Verifique sua conexão.')
    } else {
      throw new Error(`Erro ao configurar requisição: ${error.message}`)
    }
  }
}
